(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.nvk-countdown').forEach(function (root) {
    var cycleMs = (parseInt(root.dataset.cycleMinutes, 10) || 480) * 60000;
    var h = root.querySelector('[data-cd-h]');
    var m = root.querySelector('[data-cd-m]');
    var s = root.querySelector('[data-cd-s]');
    function pad(n) {
      return String(n).padStart(2, '0');
    }
    function tick() {
      var rem = cycleMs - (Date.now() % cycleMs);
      var totalSec = Math.floor(rem / 1000);
      h.textContent = pad(Math.floor(totalSec / 3600));
      m.textContent = pad(Math.floor((totalSec % 3600) / 60));
      s.textContent = pad(totalSec % 60);
    }
    tick();
    setInterval(tick, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
